import React from 'react'
import { PropTypes } from 'prop-types'

import {
  Container,
  Input,
  Select,
  AsyncCombobox,
  Button,
} from '@sainsburys-tech/fable'

import { Search } from '@sainsburys-tech/icons'
import toTitleCase from '../../utils/common'
import api from '../../utils/api'

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props)
    const { contractor } = this.props
    this.state = {
      jobTitleListItems: [],
      forename: contractor === null ? '' : contractor.forename,
      surname: contractor === null ? '' : contractor.surname,
      email: contractor === null ? '' : contractor.email,
      employerId: contractor === null ? null : contractor.employerId,
      employerName: contractor === null ? undefined : contractor.employerName,
      jobRoleId: contractor === null ? 0 : contractor.jobRoleId,
      telephoneNumber: contractor === null ? '' : contractor.telephoneNumber,
      vehicleRegistration: contractor === null ? '' : contractor.vehicleRegistration,
      emailAvailable: contractor !== null,
      emailBlured: Boolean(contractor && contractor.email)
    }
  }

  componentDidMount() {
    const {
      setHeader,
      setSignOutHeader,
      contractor,
      history
    } = this.props

    setHeader()
    setSignOutHeader(false)

    if (contractor == null || !contractor.acceptedTCs) {
      history.push('/register')
      return
    }

    this.getJobTitleDropDownData()
    if (contractor && contractor.email) {
      this.checkEmailExists(contractor.email)
    }

    if (contractor) {
      this.setState({ jobRoleId: contractor.jobRoleId })
    }

    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    this.siteContractorDetails()
  }

  getJobTitleDropDownData = () => {
    api.getJobRoles()
      .then((data) => {
        this.setState({ jobTitleListItems: data })
      })
      .catch(e => console.log(e))
  }

  getCompanies = () => api.getAllEmployers()
    .then(data => data.map(item => ({ value: String(item.id), label: item.name })))
    .catch((e) => {
      console.log(e)
      return []
    })

  handleMobileChange = (value) => {
    const regex = /^[0-9\b]+$/

    if (value === '' || regex.test(value)) {
      this.setState({ telephoneNumber: value.trim() })
    }
  }

  handleVehicleRegChanges = (value) => {
    const regex = /^[0-9A-Za-z]*$/
    if (value === '' || regex.test(value)) {
      this.setState({ vehicleRegistration: value.trim().toUpperCase() })
    }
  }

  handleEmployerInputChange = (value) => {
    this.setState({ employerName: value, employerId: 0 })
  }

  handleEmployerSelection = (option) => {
    if (!option || Array.isArray(option)) return

    this.setState({
      employerId: parseInt(option.value, 10),
      employerName: option.label,
    })
  }

  clearEmployerSelection = () => {
    this.setState({ employerId: 0, employerName: undefined })
  }

  handleJobRoleDropdownChange = (value) => {
    if (!value) {
      this.setState({ jobRoleId: 0 })
    } else {
      this.setState({ jobRoleId: parseInt(value, 10) })
    }
  }

  checkEmailExists = (email) => {
    if (email && email.includes('@')) {
      return api.CheckEmailUsernameExistsAndActive(email)
        .then((res) => {
          if (res.status === 404 || res.status === 401) {
            this.setState({ emailAvailable: false })
            return
          }
          this.setState({ emailAvailable: !res })

          return res
        })
    }
  }

  checkAllFieldsValid = () => {
    const {
      forename, surname, telephoneNumber, employerId, jobRoleId, email, emailAvailable
    } = this.state

    if (forename === ''
      || surname === ''
      || telephoneNumber === ''
      || jobRoleId === 0
      || !employerId
      || employerId === 0
      || (email === undefined ? true : !email.includes('@'))
      || !emailAvailable
    ) {
      return false
    }
    return true
  }

  handleTextChange = (value, key) => {
    this.setState({ [key]: toTitleCase(value) })
  }

  handleEmailChange = (value) => {
    const regex = /^[0-9A-Za-z@\-_.]*$/

    this.setState({ emailBlured: false })

    if (value === '' || regex.test(value)) {
      this.setState({ email: value })
    }
  }

  handleSubmit = async () => {
    const { history } = this.props
    if (this.checkAllFieldsValid()) {
      const { email } = this.state

      this.siteContractorDetails()
      history.push('/register/username')

      // const emailExists = await this.checkEmailExists(email)
      // if (!emailExists) {
      //   this.siteContractorDetails()
      //   history.push('/register/username')
      // }
    } else {
      history.push('/register')
    }
  }

  siteContractorDetails = () => {
    const {
      forename,
      surname,
      email,
      employerId,
      jobRoleId,
      telephoneNumber,
      vehicleRegistration,
      employerName
    } = this.state

    const { contractor, siteContractor } = this.props

    const contractorView = {
      forename,
      surname,
      email,
      employerId,
      jobRoleId,
      telephoneNumber,
      vehicleRegistration,
      employerName,
      acceptedTCs: contractor !== null ? contractor.acceptedTCs : false
    }

    siteContractor(contractorView)
  }

  setEmailBlur = () => {
    const { email } = this.state
    if (email.includes('@')) {
      this.setState({ emailBlured: true, errorMsg: '', emailAvailable: true }, this.handleEmailError)
      // this.checkEmailExists(email).then((exists) => {
      //   this.setState({ emailBlured: true, errorMsg: '', emailAvailable: !exists }, this.handleEmailError)
      // })
    } else {
      this.setState({ emailBlured: true, errorMsg: '' }, this.handleEmailError)
    }
  }

  getEmailStatus = () => {
    const { emailBlured, email, emailAvailable } = this.state
    let errorMsg = ''

    if (!email.includes('@')) {
      errorMsg = 'must include the @ symbol'
    }
    if (!emailAvailable) {
      errorMsg = 'is already in use'
    }
    if (email === '') {
      errorMsg = ''
    }

    if (!emailBlured || errorMsg === '') return undefined
    return { type: 'error', message: `Your email address ${errorMsg}` }
  }

  render() {
    const {
      forename,
      surname,
      email,
      jobTitleListItems,
      vehicleRegistration,
      telephoneNumber,
      jobRoleId,
      employerName,
      emailBlured
    } = this.state

    return (
      <div className="dsib-registration">
        <Container size="xl">
          <div className="dsib-registration__inner">
            <h2 className="dsib-registration__title">Register</h2>

            <div className="dsib-registration__fields">
              <div className="dsib-registration__field">
                <Input
                  label="First name"
                  value={forename}
                  isRequired
                  onChange={value => this.handleTextChange(value, 'forename')}
                  inputProps={{
                    id: 'txtForename',
                    name: 'txtForename',
                    maxLength: 50,
                    autoComplete: 'given-name'
                  }}
                />
              </div>

              <div className="dsib-registration__field">
                <Input
                  label="Last name"
                  value={surname}
                  isRequired
                  onChange={value => this.handleTextChange(value, 'surname')}
                  inputProps={{
                    id: 'txtSurname',
                    name: 'txtSurname',
                    maxLength: 50,
                    autoComplete: 'family-name'
                  }}
                />
              </div>

              <div className="dsib-registration__field dsib-registration__field--full">
                <Input
                  label="Email"
                  value={email}
                  isRequired
                  status={emailBlured ? this.getEmailStatus() : undefined}
                  onChange={this.handleEmailChange}
                  onBlur={this.setEmailBlur}
                  supportingText="We'll send you an email to verify this address before you can log in."
                  inputProps={{
                    id: 'txtEmail',
                    name: 'txtEmail',
                    maxLength: 250,
                    autoComplete: 'email'
                  }}
                />
              </div>

              <div className="dsib-registration__field dsib-registration__field--full">
                <AsyncCombobox
                  label="Company"
                  placeholder="Start typing your company name"
                  leadingIcon={<Search />}
                  isRequired
                  isClearable
                  debounceWaitTime={300}
                  value={employerName || ''}
                  onChange={this.handleEmployerInputChange}
                  onSelection={this.handleEmployerSelection}
                  onClear={this.clearEmployerSelection}
                  options={(value) => {
                    if (!value || value.length < 3) return Promise.resolve([])
                    return this.getCompanies().then((options) => {
                      const lower = value.toLowerCase()
                      return options.filter(opt => opt.label.toLowerCase().includes(lower))
                    })
                  }}
                  inputProps={{
                    id: 'company',
                    name: 'company'
                  }}
                />
              </div>

              <div className="dsib-registration__field">
                <Select
                  label="Job title"
                  isRequired
                  placeholder="Select a job title"
                  value={jobRoleId ? String(jobRoleId) : ''}
                  options={jobTitleListItems.map(item => ({ value: String(item.id), label: item.name }))}
                  onChange={this.handleJobRoleDropdownChange}
                  name="jobRole"
                />
              </div>

              <div className="dsib-registration__field">
                <Input
                  label="Mobile number"
                  value={telephoneNumber}
                  onChange={this.handleMobileChange}
                  inputProps={{
                    id: 'txtTelephoneNumber',
                    name: 'txtTelephoneNumber',
                    maxLength: 20,
                    inputMode: 'numeric',
                    autoComplete: 'tel'
                  }}
                />
              </div>

              <div className="dsib-registration__field">
                <Input
                  label="Vehicle registration (optional)"
                  value={vehicleRegistration}
                  onChange={this.handleVehicleRegChanges}
                  inputProps={{
                    id: 'txtRegistration',
                    name: 'txtRegistration',
                    maxLength: 20,
                    autoComplete: 'off'
                  }}
                />
              </div>
            </div>

            <div className="dsib-registration__actions">
              <Button
                type="button"
                variant="primary"
                isFullWidth
                onClick={this.handleSubmit}
                disabled={!this.checkAllFieldsValid()}
              >
                Next
              </Button>
            </div>
          </div>
        </Container>
      </div>
    )
  }
}

RegistrationForm.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  siteContractor: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  setHeader: PropTypes.func.isRequired,
  contractor: PropTypes.shape({
    forename: PropTypes.string,
    surname: PropTypes.string,
    jobRoleId: PropTypes.number,
    telephoneNumber: PropTypes.string,
    employerId: PropTypes.number,
    carRegistration: PropTypes.string
  })
}

RegistrationForm.defaultProps = {
  contractor: null
}
export default RegistrationForm
